import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {AccountAPI} from '../../services/accountAPI';

@inject(Router, AuthService, UserMessageService, AccountAPI)
export class Home {
  constructor(router, authService, userMessageService, api) {
    this.api = api;
    this.router = router;
    this.authService = authService;
    this.userMessageService = userMessageService;

    this.captureKey == null;
    const account = this.authService.getAccount();

    this.app_name = window.whitelabel ? window.app_name : "Magnfi";
    this.org_name = account.org_name ? account.org_name : "Magnfi";

    this.isAdmin = this.authService.getUser().role == "WLADMIN" || this.authService.getUser().role == "ADMIN";
   
    this.id = this.authService.getUser();
    console.log("this.id", this.id);
    this.dashboardlength = 'col-sm-12';
    this.rout = "";
    this.rout =(localStorage.getItem('rout'))? localStorage.getItem('rout') : ""; 
    if(this.rout.includes("#/user/home") || this.rout == "#/user" || this.rout == "#/user/embed" || this.rout == "#/user/account" || this.rout == "#/user/resetPassword" || this.rout == ""  || this.rout === "#/user/video/request" || this.rout === "#/user/video/caseStudy" || this.rout.includes("#/user/video/email"))
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9';
      console.log("Dashboard value is",this.isdashboard);
    }
  }

  attached() {
    this.setData();
    this.load();

    let scriptElement = document.createElement('script');

    scriptElement.src = this.site_url + "/api/app/getLinkScript/" + this.link_id;


    //this.scriptElementInHead = document.querySelector('#linkcode1').appendChild(scriptElement);
  
  }

  load() {
    console.log("window...",window);

    this.api.getByOwner(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }

  saveLoadSuccess(data) {
    this.authService.setAccount(data);
    this.captureKey = data.link_id;
    this.setData();
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
  }

  setData() {
    const account = this.authService.getAccount();

    this.site_url = window.site_url;

    this.biz_url = account.biz_url;
    this.bizUrl = this.biz_url;

    this.link_id = account.link_id;

    var mlinkImg = window.whitelabel ? "/api/whitelabel/getFile?file=link_icon&t=" + new Date() :  '/images/magnfi-m.png';;
    //var logoPath = window.whitelabel ? '/api/account/getLogoFile?Authorization=' + this.authService.getUser().token + '&t=' + new Date() + "&size=small" :  '/images/magnfi-m.png';
    var logoPath = '/api/account/getLogoFile?Authorization=' + this.authService.getUser().token + '&t=' + new Date() + "&size=small";

    let affiliateCount = account.affiliate_count;
    this.affiliateCountMessage = (affiliateCount === 1) ? 'You have 1 affiliate.' : `You have ${affiliateCount} affiliates.`;
    this.affiliateInfoLink = window.affiliate_info_url;
    this.affiliateTermsLink = window.affiliate_terms_url;
    this.showAffiliateCount = account.joined_affiliate_program !== null;
    this.requestCount = account.request_count;
    this.pendingRequests = account.pending_requests;
    this.acceptedRequests = account.accepted_requests;
    this.expiringRequests = account.expiring_requests;
    this.accountActive = account.status == '2';
    this.magnfiLink = this.site_url + '/biz/' + (account.biz_url ? account.biz_url : account.link_id);
    this.magnfiLinkImg = this.site_url + logoPath;
    this.magnfiLinkCode = "<p><a href='" + this.magnfiLink + "' target='_blank' rel='noopener noreferrer'><img src='" + this.magnfiLinkImg + "' style='max-width: 50px'/></a></p>";
    this.testimonial_expire_days = window.testimonial_expire_days;
    this.subscriptionType = account.subscription_type || '';
    this.visitVideoReviewPageParam = account.biz_url ? account.biz_url : account.link_id;

    this.offset = new Date().getTimezoneOffset();
    if(this.offset<0)
      this.offset = "GMT +"+this.offset/-60;
    else
      this.offset = "GMT -"+this.offset/60;

    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    var date = new Date();
    var h = date.getHours();
    var m = date.getMinutes();
    var session = "AM"; 
    
    //conditions for times behavior 
    if ( h == 0 ) {
      h = 12;
    }
    if( h >= 12 ){
      session = "PM";
    }
    
    if ( h > 12 ){
      h = h - 12;
    }
    m = ( m < 10 ) ? m = "0" + m : m;
    this.current_time = h + ":" + m + " " + session;
  }

  saveBizUrl() {
    this.api.saveBizUrl(
      this.bizUrl,
      this.authService.getUser().token,
      () => { 
        
        this.userMessageService.setUserMessage('user', 'Custom URL Saved!'); 
        this.load(); 
      },
      this.saveLoadError.bind(this));
  }

  copyLinkCode1() {
    var code = " <span style='display: inline-block; border: solid 1px black; padding: 3px; font-family: Verdana, \"Lato\", sans-serif;'><a href='" + this.magnfiLink + "' rel='noopener noreferrer' target='_blank' style='text-decoration: none;'>See Our ";
    code += "<span style='display: inline-block; position: relative'><img src='" + this.magnfiLinkImg + "' style='max-width: 50px; vertical-align: middle; line-height: 1em; height: 50px;' />";
    code += "<span style='position: relative; top:-15px;display: inline-block; text-align: center; font-size: 10px; line-height: 1em; min-width: 10px; border: solid 2px black; border-radius: 25px; padding: 3px;'><span id='__m_pubvid_count'></span></span></span> Video Reviews</a></span>";
    code += "<script type='text/javascript' src='" + this.site_url + "/api/app/getLinkScript/" + this.link_id + "'></script>";
    
    this.copyTextToClipboard(code);
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  copyLinkCode2() {
    var code = "<span style='display: inline-block; border: solid 1px black; padding: 3px; font-family: Verdana, \"Lato/\", sans-serif;'><a href='" + this.magnfiLink + "' rel='noopener noreferrer' target='_blank' style='text-decoration: none;'>";
    code += "<img src='" + this.magnfiLinkImg + "' style='max-width: 50px; vertical-align: middle; line-height: 1em; height: 50px;' /> Leave a Video Review with " + this.app_name + "</a></span>";
  
    this.copyTextToClipboard(code);
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }
  
  uploadVideo() {
    this.router.navigate("#/capture/brand/" + this.captureKey + "?method=fileupload&uploadonly=1");
  }

  clickReviewPage() {
    this.api.updateVideoReviewPageAccessCount(this.visitVideoReviewPageParam,()=>{

    }, ()=> {

    });
      
    window.open(this.magnfiLink, "_blank");
  }

  clickShortReviewPage() {
    window.open(this.magnfiLink + "?short=true", "_blank");
  }

  copyShortReviewPage() {
    this.copyTextToClipboard(this.magnfiLink + "?short=true");
    this.userMessageService.setUserMessage('user', 'Copied!'); 
  }

  onNavigate() {
    this.navPanelClass = '';
  }

  navigateLink(route, replace = false) {
    console.log("route param",route);
    localStorage.setItem('rout', route);
    if(route.includes("#/user/home") || route == "#/user" || route == "#/user/embed" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9';
      console.log("Dashboard value is",this.isdashboard);
    }
    if(route.includes("#/user/video/email"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=3" + "?videoUpload=1";
      else
      route = route + "?captureType=3";
      // window.location.href = "Posts?Category=" + sel;
    }


    this.router.navigate(route, { replace: replace });
    this.onNavigate();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
